import React from "react";

const ProfessionalTax = () => {
    return <div>ProfessionalTax</div>
}

export default ProfessionalTax;